// Libraries
import styled from 'styled-components';

// Components
import { CardGridProps } from './CardGrid.types';
import { Col } from '../elements/Col';

export const Container = styled(Col)<CardGridProps>`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(25em, 1fr));
  gap: ${({ gap = '16px' }) => gap};
  margin: 0;
  padding: 0;
  width: 100%;
`;
